import React, {useState, useEffect} from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import {Tooltip} from 'react-tooltip';  // Исправлено

import {getFirestore, collection, addDoc, query, where, getDocs, doc, getDoc} from 'firebase/firestore';
import {useParams} from 'react-router-dom';
import {getAuth} from 'firebase/auth';
import AnimationRevealPage from '../../../components/helpers/AnimationRevealPage';
import MainCabinetHeader from '../../../components/headers/MainCabinetHeader';
import InfoIconSrc from '../../../images/img/info.png';
import {MdDelete} from "react-icons/md";
import {ExpecteLink} from "../../../components/misc/Headings.js";
import {toast, Toaster} from 'react-hot-toast'; // Импортируем toast и Toaster
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Подключение стилей
import {useNavigate} from 'react-router-dom';
import Footer from "../../../components/footers/MainFooterWithLinks";
import {useTranslation} from "react-i18next";


const PageContainer = styled.div`
    ${tw`min-h-screen  flex flex-col`}
`;

const HighlightedText = styled.span`
    ${tw`text-primary-500`}
    color: #0ABD19;
`;

const FormContainer = styled.div`
    ${tw`flex justify-center items-center flex-grow py-10`}
`;

const Container = styled.div`
    ${tw`w-full max-w-6xl p-8 bg-white shadow-lg rounded-lg border`}
    border: 2px solid #1BA557;
    border-radius: 15px;
    padding: 60px 57px;
`;


const Form = styled.form`
    ${tw`grid grid-cols-2 gap-6`}
`;

const FormGroup = styled.div`
    ${tw`relative flex flex-col mb-6`}
`;

const Label = styled.label`
    ${tw`mt-1 sm:mt-0 mb-2 font-medium text-lg text-secondary-100 leading-loose`}
`;

const Text = styled.h6`
    ${tw`text-gray-500 font-bold tracking-widest text-lg`}
    margin-top: 20px;
    margin-bottom: 50px;
`;

const Input = styled.input`
    ${tw`mt-2 first:mt-0 py-3 font-medium text-sm`}
    color: #6c757d;
    font-family: inherit;
    border: none;
    border-bottom: 2px solid #adb5bd;

    &::placeholder {
        color: #adb5bd;
    }

    &:hover {
        border-bottom-color: #0ABD19;
    }

    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }

    /* Убираем стрелочки */

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }
`;


const InputSpis = styled.input`
    ${tw`mt-2 first:mt-0 py-3 focus:outline-none font-medium transition duration-300 border-b-2`}
    color: #6c757d;
    border-color: transparent;
    border-bottom-color: #adb5bd;
    font-family: inherit;

    &::placeholder {
        color: #adb5bd;
    }

    &:hover {
        border-bottom-color: #0ABD19;
    }

    &:focus {
        border-bottom-color: #0ABD19;
    }
`;

const TextArea = styled.textarea`
    ${tw`mt-2 w-full py-3 px-4 font-medium text-sm rounded resize-none`}
    height: 80px; /* можно скорректировать */
    color: #6c757d;
    border: none;
    border-bottom: 2px solid #adb5bd;
    font-family: inherit;

    &::placeholder {
        color: #adb5bd;
    }

    &:hover {
        border-bottom-color: #0ABD19;
    }

    &:focus {
        outline: none;
        border-bottom-color: #0ABD19;
    }

    /* Убираем стрелочки (если вдруг наследуются от input) */

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    -moz-appearance: none;
`;


const CustomSelectWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const CustomSelect = styled.div`
    ${tw`mt-2 w-full px-4 py-3 bg-white text-left rounded-md shadow-sm border border-gray-300 cursor-pointer`}
    color: #6c757d;
    width: 95% !important;
    font-family: inherit;

    &:hover {
        border-color: #0ABD19;
    }
`;

const CustomOptions = styled.ul`
    ${tw`absolute z-10 w-full mt-1 bg-white shadow-lg rounded-md`}
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ddd;
    list-style: none;
    margin: 0;
    padding: 0;
`;

const CustomOption = styled.li`
    ${tw`px-4 py-3 text-black cursor-pointer`}
    &:hover {
        background: #f3f4f6;
    }

    ${({isSelected}) => isSelected && tw`bg-gray-200`}
`;

const SelectArrow = styled.div`
    ${tw`absolute right-0 top-0 h-full flex items-center px-2 pointer-events-none`}
    &::after {
        content: '▾';
        font-size: 2em;
        color: #0ABD19;
        margin-left: -10px; /* перемещение стрелки левее */
    }
`;

const SecondSelectArrow = styled.div`
    ${tw`absolute right-0 top-0 h-full flex items-center px-2 pointer-events-none`}
    margin-right: 5%;

    &::after {
        content: '▾';
        font-size: 2em;
        color: #0ABD19;
        margin-left: -10px; /* перемещение стрелки левее */
    }
`;


const TextAreaContainer = styled.div`
    ${tw`relative`}
`;


const IconContainer = styled.div`
    ${tw`absolute right-0 mt-5 transform translate-y-3 cursor-pointer`}
    width: 20px;
    margin-top: 60px;
    height: 20px;


    img {
        width: 20px;
        height: 20px;
    }
`;

const InfoIconComment = styled(IconContainer)`margin-top: -35px`;

const ButtonContainer = styled.div`
    ${tw`flex justify-center mt-10`}
    gap: 20px;
    margin-bottom: 50px; /* Добавляет отступ внизу */
`;


const Button = styled.button`
    ${tw`px-8 py-3 font-bold text-white rounded-full focus:outline-none transition-transform duration-300`}
    background-color: #0ABD19;
    border: none;

    &:hover {
        background-color: #0ABD50;
        transform: scale(1.05);
    }
`;

const WhiteButton = styled(Button)`
    ${tw`text-white bg-red-600 border border-green-600`}
    &:hover {
        background-color: #9a0000;
    }
`;

const Actions = styled.div`
    ${tw`relative max-w-md text-center mx-auto lg:mx-0`}
    button {
        ${tw`w-[200px] sm:relative sm:right-0 sm:top-0 sm:bottom-0 bg-green-500 text-white font-bold mr-2 my-4 sm:my-2 rounded-full py-4 flex items-center justify-center sm:leading-none focus:outline-none transition duration-300`}
        background-color: #0ABD19;
        border: none;

        &:hover,
        &:focus {
            background-color: #09d85c;
            transform: scale(1.1);
        }
    }
`;

const StepTitle = tw(ExpecteLink)`w-full mt-2 mb-4`;

const DeleteIconContainer = styled.div`
    ${tw`flex justify-end`}
    svg {
        ${tw`w-6 h-6 cursor-pointer`}
        color: red;

        &:hover {
            color: darkred;
        }
    }
`;
const AddInput = styled.input`
    ${tw`ml-4 w-auto bg-gray-300 text-gray-600 font-bold py-3 rounded-full flex items-center justify-center leading-none focus:outline-none transition duration-300`}
    border: none;
    width: 200px;
    height: 40px;
    padding: 0 1rem;

    &:hover,
    &:focus {
        transform: scale(1.1);
        background-color: #0ABD19;
        color: white;
    }

    &:focus::placeholder {
        color: transparent;
    }
`;
const BackButton = styled(AddInput)`
    ${tw`w-auto bg-gray-300 text-gray-600 font-bold py-3 px-4 rounded-full flex items-center justify-center leading-none focus:outline-none transition duration-300 ml-auto`}
`;

const ProductForm = ({index, handleChange, handleDelete}) => {
    const {t} = useTranslation();

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedType, setSelectedType] = useState(t('forms.product.type.label'));
    const productTypes = t('forms.product.type.options', {returnObjects: true});

    return (
        <>
            <StepTitle>
                <HighlightedText>{t("forms.product.title", {index: index + 1})}</HighlightedText>
                <DeleteIconContainer>
                    <MdDelete onClick={() => handleDelete(index)}/>
                </DeleteIconContainer>
            </StepTitle>
            <Form>
                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productType-${index}`}>
                        {t("forms.productType")} *
                    </Label>
                    <CustomSelectWrapper>
                        <CustomSelect onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                            {selectedType}
                            <SecondSelectArrow/>
                        </CustomSelect>
                        {isDropdownOpen && (
                            <CustomOptions>
                                {productTypes.map(type => (
                                    <CustomOption
                                        key={type}
                                        onClick={() => {
                                            setSelectedType(type);
                                            handleChange({target: {id: `productType`, value: type}}, index);
                                            setIsDropdownOpen(false);
                                        }}


                                        isSelected={type === selectedType}
                                    >
                                        {type}
                                    </CustomOption>
                                ))}
                            </CustomOptions>
                        )}
                    </CustomSelectWrapper>
                    <Tippy content={t("forms.tooltipProductType")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>


                </FormGroup>
                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productBrand-${index}`}>{t("forms.labelProductBrand")}</Label>
                    <Input
                        id={`productBrand-${index}`}
                        type="text"
                        placeholder={t("forms.placeholderProductBrand")}
                        onChange={(e) => handleChange(e, index)}
                    />
                    <Tippy content={t("forms.tooltipProductBrand")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>

                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productColor-${index}`}>{t("forms.labelProductColor")}</Label>
                    <Input
                        id={`productColor-${index}`}
                        type="text"
                        placeholder={t("forms.placeholderProductColor")}
                        onChange={(e) => handleChange(e, index)}
                    />
                    <Tippy content={t("forms.tooltipProductColor")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>

                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productQuantity-${index}`}>{t("forms.labelProductQuantity")}</Label>
                    <Input
                        id={`productQuantity-${index}`}
                        type="number"
                        placeholder={t("forms.placeholderProductQuantity")}
                        onChange={(e) => handleChange(e, index)}
                    />
                    <Tippy content={t("forms.tooltipProductQuantity")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>

                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productPrice-${index}`}>{t("forms.labelProductPrice")}</Label>
                    <Input
                        id={`productPrice-${index}`}
                        type="number"
                        placeholder={t("forms.placeholderProductPrice")}
                        onChange={(e) => handleChange(e, index)}
                    />
                    <Tippy content={t("forms.tooltipProductPrice")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>

                <FormGroup style={{gridColumn: 'span 1'}}>
                    <Label htmlFor={`productName-${index}`}>{t("forms.labelProductName")}</Label>
                    <Input
                        id={`productName-${index}`}
                        type="text"
                        placeholder={t("forms.placeholderProductName")}
                        onChange={(e) => handleChange(e, index)}
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                        }}
                    />
                    <Tippy content={t("forms.tooltipProductName")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>

                <FormGroup style={{gridColumn: 'span 2'}}>
                    <Label htmlFor={`productLink-${index}`}>{t("forms.labelProductLink")}</Label>
                    <Input
                        id={`productLink-${index}`}
                        type="text"
                        placeholder={t("forms.placeholderProductLink")}
                        onChange={(e) => handleChange(e, index)}
                    />
                    <Tippy content={t("forms.tooltipProductLink")} placement="top">
                        <IconContainer>
                            <img src={InfoIconSrc} alt="Info icon"/>
                        </IconContainer>
                    </Tippy>
                </FormGroup>


            </Form>
        </>
    );
};

const ExpectedLink = () => {
    const {id} = useParams(); // Получаем id из URL
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Склад не выбран');
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {t} = useTranslation();


    // Функция для показа уведомления

    const [formValues, setFormValues] = useState({
        parcelName: '',
        warehouse: '',
        trackingNumber: '',
        storeName: '',
        comment: '',
        products: [],
    });

    useEffect(() => {
        const loadParcelData = async () => {
            if (id) {
                const db = getFirestore();

                const docRef = doc(db, 'parcels', id);


                try {
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                        const parcelData = docSnap.data();

                        setFormValues({
                            parcelName: parcelData.parcelName || '',
                            warehouse: parcelData.warehouse || '',
                            trackingNumber: parcelData.trackingNumber || '',
                            storeName: parcelData.storeName || '',
                            comment: parcelData.comment || '',
                        });
                        setSelectedOption(parcelData.warehouse || t("forms.placeholderWarehouseNotSelected"));
                        setProducts(parcelData.products || []);
                    }
                } catch (error) {
                    console.error('Error loading parcel data:', error);
                }
            }
        };


        loadParcelData();
    }, [id]);


    const handleChange = (e, index = null) => {
        const {id, value} = e.target;
        if (index === null) {
            setFormValues({
                ...formValues,
                [id]: value,
            });
        } else {
            const updatedProducts = [...products];
            updatedProducts[index] = {
                ...updatedProducts[index],
                [id.replace(`-${index}`, '')]: value, // Убираем индекс из ключа
            };
            setProducts(updatedProducts);
        }
    };


    const handleDelete = (index) => {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
    };

    const addProduct = () => {
        setProducts([...products, {}]);
    };

    const resetForm = () => {
        setSelectedOption(t("forms.placeholderWarehouseNotSelected"));
        setProducts([]);
        setFormValues({
            parcelName: '',
            warehouse: '',
            trackingNumber: '',
            storeName: '',
            comment: '',
            products: [],
        });
    };

    const generateFriendlyId = () => {
        const randomNum = Math.floor(100000 + Math.random() * 900000);
        return `EKZ-${randomNum}`;
    };

    const calculateTotalCost = (products) => {
        return products.reduce((total, product) => {
            const price = parseFloat(product.productPrice) || 0;
            const quantity = parseInt(product.productQuantity) || 0;
            return total + (price * quantity);
        }, 0).toFixed(2);
    };

    const calculateTotalQuantity = (products) => {
        return products.reduce((total, product) => {
            const quantity = parseInt(product.productQuantity) || 0;
            return total + quantity;
        }, 0);
    };

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        return date.toLocaleString('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        }).replace(',', '');
    };

    const handleSubmit = async () => {
        const auth = getAuth();
        if (isSubmitting) return; // Защита от повторного клика
        setIsSubmitting(true);

        const user = auth.currentUser;

        if (!user) {
            toast.error(t("forms.authRequiredToSaveParcel"));
            setIsSubmitting(false);
            return;
        }

        const requiredFields = [
            {name: t("forms.fieldParcelName"), value: formValues.parcelName},
            {name: t("forms.fieldWarehouse"), value: formValues.warehouse},
            {name: t("forms.fieldTrackingNumber"), value: formValues.trackingNumber},
            {name: t("forms.fieldStoreName"), value: formValues.storeName},
        ];

        const emptyFields = requiredFields.filter(field => !field.value.trim());

        if (emptyFields.length > 0) {
            const fieldNames = emptyFields.map(field => field.name).join(', ');
            toast.error(t("forms.requiredFieldsMissing", {fields: fieldNames}));
            setIsSubmitting(false);
            return;
        }

        if (products.length === 0) {
            toast.error(t("forms.addAtLeastOneProduct"));
            setIsSubmitting(false);
            return;
        }


        // Проверяем, что все поля для каждого товара заполнены
        const incompleteProducts = products.filter(product => {
            return (
                !product.productType?.trim() ||
                !product.productBrand?.trim() ||
                !product.productColor?.trim() ||
                !product.productQuantity ||
                !product.productPrice ||
                !product.productName?.trim() ||
                !product.productLink?.trim()
            );
        });

        if (incompleteProducts.length > 0) {
            toast.error(t("forms.fillAllProductFields"));
            setIsSubmitting(false);
            return;
        }

        const db = getFirestore();

        try {
            const q = query(collection(db, 'users'), where('email', '==', user.email));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                const userData = querySnapshot.docs[0].data();
                const correctUserId = userData.userId;

                const totalCost = calculateTotalCost(products);
                const totalQuantity = calculateTotalQuantity(products);
                const friendlyId = generateFriendlyId();
                const formattedDateTime = formatDateTime(new Date().toISOString());
                // Проверяем, не существует ли уже посылка с таким же трек-номером у этого пользователя
                const checkDuplicate = query(
                    collection(db, 'parcels'),
                    where('userId', '==', correctUserId),
                    where('trackingNumber', '==', formValues.trackingNumber.trim())
                );

                const duplicateSnapshot = await getDocs(checkDuplicate);
                if (!duplicateSnapshot.empty) {
                    toast.error(t("forms.duplicateTracking"));
                    setIsSubmitting(false);
                    return;
                }


                // Создание посылки
                await addDoc(collection(db, 'parcels'), {
                    ...formValues,
                    products,
                    userId: correctUserId,
                    createdAt: formattedDateTime,
                    status: 'Создана',
                    totalCost,
                    totalQuantity,
                    id: friendlyId,
                });

                // Добавление уведомления
                await addDoc(collection(db, 'notifications'), {
                    userId: user.uid,
                    message: `Ваша посылка ${friendlyId} была создана`,
                    timestamp: new Date(),
                });

                // Показываем уведомление
                toast.success(t("forms.parcelSaved"));
                // Перенаправление после успешного сохранения
                setTimeout(() => {
                    navigate('/IncomingParcels');
                }, 2000); // 2000 миллисекунд = 2 секунды

            } else {
                toast.success(t("forms.parcelSaved"));
            }
        } catch (error) {
            toast.success(t("forms.parcelSaved"));
        }
        setIsSubmitting(false);

    };


    const options = [t("forms.warehouseNotSelected"), t("forms.usa")];

    return (
        <AnimationRevealPage>
            <MainCabinetHeader/>
            <PageContainer>
                <Toaster/>

                <FormContainer>

                    <div style={{width: '100%', maxWidth: '1280px'}}>
                        <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "20px"}}>
                            <BackButton
                                type="button"
                                value={t("forms.backToCabinet")}
                                onClick={() => window.history.back()}
                            />
                        </div>
                        <StepTitle active={true}>
                            <HighlightedText>{t("forms.step1")}</HighlightedText>{t("forms.fillParcelInfo")}
                        </StepTitle>

                        <Container>
                            <Form>
                                <FormGroup>
                                    <Label htmlFor="parcelName">{t("forms.parcelName.label")}</Label>
                                    <Input
                                        id="parcelName"
                                        type="text"
                                        placeholder={t("forms.parcelName.placeholder")}
                                        value={formValues.parcelName}
                                        onChange={handleChange}
                                    />

                                    <Tippy content={t("forms.parcelName.tooltip")} placement="top">
                                        <IconContainer>
                                            <img src={InfoIconSrc} alt="Info icon" />
                                        </IconContainer>
                                    </Tippy>
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="warehouse">{t("forms.warehouse.label")}</Label>
                                    <CustomSelectWrapper>
                                        <CustomSelect onClick={() => setIsOpen(!isOpen)}>
                                            {selectedOption}
                                        </CustomSelect>
                                        {isOpen && (
                                            <CustomOptions>
                                                {options.map(option => (
                                                    <CustomOption
                                                        key={option}
                                                        onClick={() => {
                                                            setSelectedOption(option);
                                                            setFormValues({
                                                                ...formValues,
                                                                warehouse: option,
                                                            });
                                                            setIsOpen(false);
                                                        }}
                                                        isSelected={option === selectedOption}
                                                    >
                                                        {option}
                                                    </CustomOption>
                                                ))}
                                            </CustomOptions>
                                        )}
                                    </CustomSelectWrapper>
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="trackingNumber">{t("forms.trackingNumber.label")}</Label>
                                    <Input
                                        id="trackingNumber"
                                        type="text"
                                        placeholder={t("forms.trackingNumber.placeholder")}
                                        value={formValues.trackingNumber}
                                        onChange={handleChange}
                                    />
                                    <Tippy content={t("forms.trackingNumber.tooltip")}>
                                        <IconContainer>
                                            <img src={InfoIconSrc} alt="Info icon" />
                                        </IconContainer>
                                    </Tippy>
                                </FormGroup>

                                <FormGroup>
                                    <Label htmlFor="storeName">{t("forms.storeName.label")}</Label>
                                    <Input
                                        id="storeName"
                                        type="text"
                                        placeholder={t("forms.storeName.placeholder")}
                                        value={formValues.storeName}
                                        onChange={(e) => {
                                            const onlyEnglishRegex = /^[A-Za-z\s]*$/;
                                            if (onlyEnglishRegex.test(e.target.value)) {
                                                handleChange(e);
                                            }
                                        }}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                        }}
                                    />
                                    <Tippy content={t("forms.storeName.tooltip")}>
                                        <IconContainer>
                                            <img src={InfoIconSrc} alt="Info icon" />
                                        </IconContainer>
                                    </Tippy>
                                </FormGroup>


                                <FormGroup style={{ gridColumn: 'span 2' }}>
                                    <Label htmlFor="comment">{t("forms.comment.label")}</Label>
                                    <TextAreaContainer>
                                        <TextArea
                                            id="comment"
                                            placeholder={t("forms.comment.placeholder")}
                                            rows="4"
                                            value={formValues.comment}
                                            onChange={handleChange}
                                        />
                                        <Tippy content={t("forms.comment.tooltip")}>
                                            <InfoIconComment style={{ marginTop: '-59px' }}>
                                                <img src={InfoIconSrc} alt="Info icon" />
                                            </InfoIconComment>
                                        </Tippy>
                                    </TextAreaContainer>
                                </FormGroup>

                            </Form>
                        </Container>
                    </div>
                </FormContainer>
                <FormContainer>
                    <div style={{ width: '100%', maxWidth: '1280px' }}>
                        <StepTitle active={false}>
                            <HighlightedText>{t("forms.step2.step")} </HighlightedText>
                            {t("forms.step2.title")}
                        </StepTitle>
                        <Container>
                            <Text>{t("forms.step2.description")}</Text>
                            {products.map((_, index) => (
                                <ProductForm key={index} index={index} handleChange={handleChange} handleDelete={handleDelete} />
                            ))}
                            <Actions>
                                <button type="button" onClick={addProduct}>{t("forms.step2.addProduct")}</button>
                            </Actions>
                        </Container>
                    </div>
                </FormContainer>

                <ButtonContainer>
                    <Button type="button" onClick={handleSubmit}>
                        {id ? t("forms.actions.saveChanges") : t("forms.actions.saveParcel")}
                    </Button>
                    <WhiteButton type="button" onClick={resetForm}>{t("forms.actions.reset")}</WhiteButton>
                </ButtonContainer>

            </PageContainer>


            <Footer/>
        </AnimationRevealPage>
    );
};

export default ExpectedLink;
